import * as Sentry from '@sentry/angular';

export function buildSentryIOOptions(appOptions): Sentry.BrowserOptions {
	const sentryOptions: Sentry.BrowserOptions = {
		dsn: 'https://29997be62adda56ab5f6907325bcca67@o4506388793458688.ingest.sentry.io/4506406775554048',
		// Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
		tracePropagationTargets: [
			// To check if we need this.
			'127.0.0.1',
			'localhost',
			'portal.applicationlink.eu',
			'applicationlink.azurewebsites.net',
			'applicationlink-ua.azurewebsites.net',
			'applicationlink-test.azurewebsites.net',
			'cspplatform.azurewebsites.net',
			'cspplatform-ua.azurewebsites.net',
			'cspplatform-test.azurewebsites.net',
			'applicationlink.azureedge.net'
		],
		integrations: [
			Sentry.captureConsoleIntegration({
				levels: ['error']
			}),
			Sentry.replayIntegration({
				maskAllText: false,
				blockAllMedia: false,
			}),
		],
		// Performance Monitoring
		tracesSampleRate: 1.0, //  Capture 100% of the transactions
		// Session Replay
		replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
		replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
	}

	// alternative options supplied from app can overwrite default sentry options
	return Object.assign(sentryOptions, appOptions);
}
